import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/manage/product/:id',
    name: 'ProductPage',
    component: () => import('@/modules/productManagement/views/ProductPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/manage/product/:id/upgrade/options',
    name: 'UpgradeOptionsProductPage',
    component: () => import('@/modules/productManagement/views/upgrade/UpgradeOptionsProductPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/manage/product/:id/upgrade/payment',
    name: 'UpgradePaymentPage',
    component: () => import('@/modules/productManagement/views/upgrade/UpgradePaymentPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/manage/product/:id/cancel',
    name: 'RequestCancellation',
    component: () => import('@/modules/productManagement/views/RequestCancellation.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/manage/product/:id/security-groups',
    name: 'SecurityGroups',
    component: () => import('@/modules/productManagement/views/upgrade/SecurityGroups.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/manage/product/:id/configure-ssl',
    name: 'ConfigureSsl',
    component: () => import('@/modules/productManagement/views/ssl/ConfigureSslProductPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/manage/product/:id/reissue',
    name: 'ReissueSsl',
    component: () => import('@/modules/productManagement/views/ssl/ReissueSslProductPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/manage/product/:id/configure-ssl/domain-control-validation',
    name: 'ConfigureSslDomainControlValidation',
    component: () => import('@/modules/productManagement/views/ssl/ConfigureSslProductDomainPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/manage/product/:id/reissue/domain-control-validation',
    name: 'ReissueSslDomainControlValidation',
    component: () => import('@/modules/productManagement/views/ssl/ReissueSslProductDomainPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/manage/product/:id/configure-ssl/complete',
    name: 'ConfigureSslProductCompletePage',
    component: () => import('@/modules/productManagement/views/ssl/ConfigureSslProductCompletePage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/manage/product/:id/reissue/complete',
    name: 'ReissueSslProductCompletePage',
    component: () => import('@/modules/productManagement/views/ssl/ReissueSslProductCompletePage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
